<template>
  <div class="col-xs-12 col-sm-10 col-sm-offset-1">
    <div class="row">
      <form class="form-inline" v-on:submit.prevent="getStatistics">
        <div class="form-group">
          <label>Frequency</label>
          <select v-model="period" class="form-control">
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
            <option value="yearly">Yearly</option>
          </select>
        </div>
        <div class="form-group">
          <label >Number of records</label>
          <input type="number" class="form-control" v-model.number="last" />
        </div>
        <button type="submit" class="btn btn-primary">Search</button>
      </form>
    </div>
    <br/><br/>
    <div class="loader" v-if="loading">
      <img src="/static/img/loader.gif" />
    </div>

    <div v-if="!loading">
      <div class="row">
        <div class="col-lg-2 col-xs-4" v-for="(value, label, index) in total" :key="index">
          <div :class="['small-box', colors[index]]">
            <div class="inner">
              <h3>{{label=='Spending' ? value.toFixed(2) : value}}</h3>
              <p>{{label}}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="chart-responsive">
        <chartjs-line :option="chartOption" :labels="labels" :datasets="datasets" :bind="true"></chartjs-line>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../utils/api'

export default {
  name: 'all-channel-stats',
  data () {
    return {
      loading: true,
      labels: [],
      colors: ['bg-red', 'bg-green', 'bg-aqua', 'bg-blue', 'bg-yellow', 'bg-orange'],
      period: 'weekly',
      last: 7,
      total: {
        'Spending': 0,
        'Impressions': 0,
        'Reach': 0,
        'Actions': 0,
        'Callers': 0,
        'Referrals': 0
      },
      chartOption: {
        scales: {
          yAxes: [{
            position: 'right',
            id: 'y-axes-0',
            scaleLabel: {
              display: true,
              labelString: 'Percentage(%)'
            },
            ticks: {
              callback: (value, index, values) => {
                return `${value.toFixed(1)}%`
              }
            }
          }, {
            position: 'left',
            id: 'y-axes-1',
            scaleLabel: {
              display: true,
              labelString: 'Cost($)'
            },
            ticks: {
              callback: (value, index, values) => {
                return `$${value.toFixed(1)}`
              }
            }
          }]
        }
      },
      datasets: [
        {
          label: 'Caller Conversion Rate',
          backgroundColor: '#f19c12',
          borderWidth: 2,
          borderColor: '#f19c12',
          lineTension: 0.1,
          fill: false,
          yAxisID: 'y-axes-0',
          data: []
        },
        {
          label: 'Caller Acquisition Cost',
          backgroundColor: '#57c1f0',
          borderWidth: 2,
          borderColor: '#57c1f0',
          lineTension: 0.1,
          yAxisID: 'y-axes-1',
          fill: false,
          data: []
        },
        {
          label: 'Referral Acquisition Cost',
          backgroundColor: '#52a75a',
          borderWidth: 2,
          borderColor: '#52a75a',
          lineTension: 0.1,
          yAxisID: 'y-axes-1',
          fill: false,
          data: []
        }
      ]
    }
  },
  methods: {
    getData (type, count) {
      this.loading = true
      this.resetData()
      const emptyReport = {reach: 0, spend: 0, impressions: 0, action: 0}
      api.buildRequest(`funnel/global/period/${type}/${count}`, 'get')
        .then((res) => {
          const { data } = res.data
          api.buildRequest(`report?period=${type}&last=${count}`, 'get')
            .then((response) => {
              const { payload } = response.data
              for (let i = payload.length - 1; i >= 0; i--) {
                this.labels.push(payload[i].display)
                let theReport = payload[i].report.length ? payload[i].report[0] : emptyReport
                let { value } = data[i]
                let clientConversion = theReport.reach ? Number(value.accounts / theReport.reach).toFixed(2) : 0
                let callerConversion = value.accounts ? Number(theReport.spend / value.accounts).toFixed(2) : 0
                let referralAcquisition = value.referrals ? Number(theReport.spend / value.referrals).toFixed(2) : 0
                let computedValue = [theReport.spend, theReport.impressions, theReport.reach, theReport.action, value.accounts, value.referrals]
                this.computeTotal(computedValue)
                this.datasets[0].data.push(clientConversion)
                this.datasets[1].data.push(callerConversion)
                this.datasets[2].data.push(referralAcquisition)
              }
              this.loading = false
            }).catch((error) => {
              console.log(error)
            })
        })
    },
    getStatistics () {
      this.getData(this.period, this.last)
    },
    resetData () {
      for (let key in this.total) {
        this.total[key] = 0
      }
      this.labels = []
      this.datasets[0].data = []
      this.datasets[1].data = []
      this.datasets[2].data = []
    },
    computeTotal (value) {
      let counter = 0
      for (let key in this.total) {
        this.total[key] += value[counter]
        counter++
      }
    }
  },

  mounted () {
    this.getData('weekly', 7)
  }
}
</script>

<style scoped>
  .small-box h3 {
    font-size: 20px;
  }

  .small-box > .inner {
    padding: 5px;
  }
</style>



// WEBPACK FOOTER //
// AllChannelsStats.vue?4dcd565e